import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { SplitText } from "gsap/SplitText"
import { prefersReducedMotion } from "../utils/motion"

gsap.registerPlugin(ScrollTrigger, SplitText)

let revealTriggers = []

export default function initReveal() {

    // MARK: Set initial states of reveal animations
    if (prefersReducedMotion()) {
        gsap.set('[data-reveal-fade]', {
            autoAlpha: 1,
            y: 0,
            clearProps: 'opacity,visibility,transform',
        })
        return
    }

    if (document.querySelector('[data-reveal-fade]')) { gsap.set('[data-reveal-fade]', { autoAlpha: 0, y: 20 }) }

}

export function startReveal() {
    revealTriggers.forEach((trigger) => trigger.kill())
    revealTriggers = []

    if (prefersReducedMotion()) {
        gsap.set('[data-reveal-fade]', {
            autoAlpha: 1,
            y: 0,
            clearProps: 'opacity,visibility,transform',
        })
        return
    }
    
    if (document.querySelector('[data-reveal-fade]')) {
        const batchTriggers = ScrollTrigger.batch("[data-reveal-fade]", {
            batchMax: 10,
            onEnter: (elements) => {
                gsap.to(elements, {
                    autoAlpha: 1,
                    y: 0,
                    duration: 0.8,
                    stagger: 0.15,
                    ease: "power2.out",
                    clearProps: "opacity,visibility,y",
                })
            },
            start: batch => {
                if ((batch.trigger.getBoundingClientRect().top + window.scrollY) > window.innerHeight) {
                    return "top 80%"
                } else {
                    return "top bottom"
                }
            },
            once: true,
        })
        revealTriggers = Array.isArray(batchTriggers) ? batchTriggers : [batchTriggers]
    }
}
